module.exports = __webpack_public_path__ + "img/blogpost9.b0623866.jpg";